import { render, staticRenderFns } from "./emailEditor.vue?vue&type=template&id=452f1298"
import script from "./emailEditor.vue?vue&type=script&lang=js"
export * from "./emailEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports